import { BaseCheckbox } from '@/shared/components'
import { Select } from '@headlessui/react'
import clsx from 'clsx'
import { ChevronDownIcon } from 'lucide-react'
import { useState } from 'react'
import { BaseProfileCard } from '../../../../../features/profile/ui/BaseProfileCard/BaseProfileCard'

export const ProfileTimeZone = () => {
  const options = [
    { label: '(+ 03:00 UTC) Moscow', value: 'msk' },
    { label: '(-08:00 UTC) Los Andgeles', value: 'la' },
    { label: '(+ 00:00 UTC) London', value: 'london' },
  ]

  const [enabled, setEnabled] = useState(false)

  return (
    <BaseProfileCard title="Часовой пояс">
      <div className="text-text-main">
        <div className="relative mb-4 w-[350px] md:w-full md:max-w-[500px]">
          <Select
            className={clsx(
              'block px-3 py-1.5 border border-card-border dark:border-card-border-dark rounded-lg w-full text-text-main dark:text-white text-sm appearance-none',
              'focus:outline-2 focus:-outline-offset-2 focus:outline-card-border dark:focus:outline-card-border-dark',
              '*:text-black'
            )}
          >
            {options.map((o, i) => {
              return (
                <option
                  key={i}
                  value={o.value}
                  className="bg-white dark:bg-dark-bg selected:bg-light-purple"
                >
                  {o.label}
                </option>
              )
            })}
          </Select>
          <ChevronDownIcon
            className="group top-1/2 right-4 absolute fill-white/60 size-5 -translate-y-1/2 pointer-events-none"
            aria-hidden="true"
          />
        </div>
        <BaseCheckbox checked={enabled} onChange={setEnabled} label="Установить локальное время" />
      </div>
    </BaseProfileCard>
  )
}
